
import $ from "jquery";
import moment from "moment";
import { csl, u_, vuwer } from "@@assets/scripts/common";
import "@pressmedia/vuwminimalcalendar";
import getHolidaysPromise from "./___getHolidaysPromise";


// **** process ****
const now = moment();
const holidaysPromise = getHolidaysPromise(now);

vuwer.add("calendarSection", {
	selector: "#calendar_section",
	etcEvents: [],
	
	async onReadyFirst($self) {
		if(!$self) {
			return false;
		}
		
		const $body = $self.children(".section-body");
		const $footer = $self.children(".section-footer");
		const [holidays, events] = await holidaysPromise;
		// csl.log.orange("holidays", { holidays, events });
		this.setProp({ $body, $footer, holidays, events });
	},
	
	onReadyLast() {
		const len = this.etcEvents.length
		if(len && this.$footer.length) {
			// nameごとにまとめる
			const eventsByName = {};
			for(let i = 0; i < len; i++) {
				const { day, name } = this.etcEvents[i];
				
				if( !Array.isArray(eventsByName[name]) ) {
					eventsByName[name] = [];
				}
				eventsByName[name].push(day);
			}
			
			$.fn.append.apply(
				this.$footer,
				Object.keys(eventsByName).map(name => {
					return $("<div/>").addClass("holiday-exp").attr({
						"data-type": "etc"
					}).append(
						$.fn.append.apply(
							$("<div/>").addClass("days").attr({
								"data-count": eventsByName[name].length
							}),
							eventsByName[name].map(day => {
								return $("<span/>").addClass("day").text(
									day.format("M/D（ddd）")
								);
							})
						),
						$("<div/>").addClass("name").html( $.parseHTML(name) )
					);
				})
			);
		}
	}
}, function() {
	const childProps = {
		vuwType: "minimalCalendar",
		
		selector() {
			return this.container.$body.children(
				`.calendar-box[data-view="${this.name}"]`
			);
		},
		
		onPicupEventsData(date, data, holidays) {
			const { type, weekPos, daysIdx } = data;
			
			if(
				!type &&
				Array.isArray(holidays[weekPos]) &&
				Array.isArray(holidays[weekPos][daysIdx])
			) {
				// 祝日の場合は翌日に振り替える
				date.add(1, "days");
			}
		},
		
		onRenderDay($day, dataAttr, eventsOfDay) {
			if( !Array.isArray(eventsOfDay) ) {
				return false;
			}
			
			const typeList = [];
			const len = eventsOfDay.length;
			for(let i = 0; i < len; i++) {
				const event = eventsOfDay[i];
				if(event.type) {
					if(event.type === "cancel") {
						const { classPrefix } = this;
						$day.removeClass(
							`${classPrefix}has-events`
						).children(`.${classPrefix}events`).remove();
						
						csl.log.gray(`${event.day.format("MM/DD")}: canceled.`);
						return true;
						
					} else {
						typeList.push(event.type);
						event.$elm.attr({ "data-type": event.type });
						
						if(event.type === "etc") {
							this.container.container.etcEvents.push(event);
						}
					}
				}
			}
			
			!!typeList.length && $day.attr({
				"data-has-event-types": typeList.join(",")
			});
		},
		
		onEventClick($event, data) {
			csl.log.gray("event click", data);
			return false;
		},
		
		onReadyFirst() {
			const { holidays, events } = this.container;
			u_.isObject(holidays) && this.setHolidays(holidays);
			u_.isObject(events) && this.setEvents(events);
		}
	};
	
	// add child vuw
	this
	// [define current]
	.add("current", {
		...childProps,
		viewDate: now,
		onChangeMonth(viewDate, $self, holidaysOfMonth, eventsOfMonth) {
			if( viewDate.isAfter(now, "month") ) {
				$self.attr("data-cal", "next");
			} else
			if( viewDate.isBefore(now, "month") ) {
				$self.attr("data-cal", "prev");
			} else {
				$self.attr("data-cal", "current");
			}
			// this.container.renderTypeList(this.name, eventsOfMonth, true);
		}
	})
	
	// [define next]
	.add("next", {
		...childProps,
		viewDate: now.clone().add(1, "months"),
		onChangeMonth(viewDate, $self, holidaysOfMonth, eventsOfMonth) {
			$self.toggleClass("is-same-year", viewDate.isSame(now, "year"));
			// this.container.renderTypeList(this.name, eventsOfMonth);
		}
	});
	
});
